import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import styles from '../../../EpisodeSegmentPlayer/styles.sass';
import EpisodeWaveAnimationContainer from '../../../EpisodeWaveAnimationContainer';
import { getRandomizedVolumeData } from '../../../../utils';
import { AnchorLogo } from '../../../EpisodeSegmentPlayer';

const EmbedNotFound = ({ vanitySlug }) => {
  const t = useT();
  return (
    <div className={styles.embedNotFoundContainer}>
      <EpisodeWaveAnimationContainer
        isEmbedded
        fgColor="rgba(125,125,125,0.1)"
        className={styles.waveform}
        volumeData={getRandomizedVolumeData()}
        isPlaying={false}
      />
      <h4 className={styles.header}>
        {t(
          'Profile.NotFound.Title',
          "Sorry, this episode can't be found.",
          'Error message when episode is not found in the profile page'
        )}
      </h4>
      <AnchorLogo vanitySlug={vanitySlug} />
    </div>
  );
};

export { EmbedNotFound };
